import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Button,
  Box,
  Card,
  CardContent,
  IconButton,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Link,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { Password } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "../../styles/App.scss";

import "../../styles/UserStyles.css";
import "../../styles/vendorStyle.css";
import { VENDORS, VERIFY_OTP } from "../../component/common/Routes/AppRoutes";
import ControlledInputField from "../../component/ui/FormFields/ControlledTextInputField";
import CustomButton from "../../component/ui/FormFields/Button";
import { addVendorRequest } from "../../redux/Vendors/actions/vendorActions";
import { RESET_VENDOR_STATE } from "../../redux/Vendors/types/vendorTypes";
import {
  selectCityRequest,
  selectCountryRequest,
  selectStateRequest,
} from "../../redux/Common/selectorAction";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { addUserRequest, resetUserState } from "../../redux/User/UserAction";
import PasswordInput from "../../component/ui/PasswordInput";
import TopBar from "../../component/common/components/TopBar";
import Footer from "../../component/common/components/Footer";

export default function VendorRegistration() {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    setError,
    control,
    setValue,
    watch,
    register,
    clearErrors,
    formState: { errors },
  } = useForm({ mode: "onChange" });
  const success = useSelector((state) => state.user.success || false);
  const loading = useSelector((state) => state.user?.loading);
  const error = useSelector((state) => state.user.error);
  const [selectedFileName, setSelectedFileName] = useState("");
  useEffect(() => {
    dispatch(selectCountryRequest());
  }, []);

  const formValue = watch();
  const countryId = formValue.country?.value;
  const stateId = formValue.state?.value;
  const panNumber = formValue.pan_number;
  const gstinNumber = formValue.gstin_number;

  const countries = useSelector((state) => state.selector?.country?.data);
  const states = useSelector((state) => state.selector?.state?.data);
  const cities = useSelector((state) => state.selector?.city?.data);
  const countryForCode = countries?.map((value) => {
    return {
      label: ` +${value.phonecode} - ${value.short_name}`,
      value: value.phonecode,
    };
  });
  const countryName = countries?.map((country) => {
    return { value: country?.id, label: country?.country_name };
  });
  const stateName = states?.map((state) => {
    return { value: state?.id, label: state?.state_name };
  });
  const cityName = cities?.map((city) => {
    return { value: city?.id, label: city?.city_name };
  });

  useEffect(() => {
    setValue("state", "");
    setValue("city", "");
    dispatch(selectStateRequest(countryId));
  }, [countryId]);

  useEffect(() => {
    setValue("city", "");
    dispatch(selectCityRequest(stateId));
  }, [stateId]);

  useEffect(() => {
    if (countryId === 101) {
      if (panNumber || gstinNumber) {
        clearErrors(["pan_number", "gstin_number"]);
      }
      if (
        (panNumber === "" && gstinNumber === "") ||
        (panNumber === undefined && gstinNumber === undefined)
      ) {
      }
    }
  }, [panNumber, gstinNumber, countryId, clearErrors]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        setValue("documents", reader.result);
        setSelectedFileName(file.name);
      };
      reader.onerror = (error) => {
        console.error("Error converting file: ", error);
      };
    }
  };
  const vendorFields = [
    {
      name: "agency_name",
      label: "Agency / Company Name *",
      placeholder: "Enter your agency name",
      rules: { required: "Agency / Company Name is required" },
      icon: <BusinessIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "first_name",
      label: "First Name *",
      placeholder: "Enter your first name",
      rules: { required: "First Name is required" },
      icon: <PersonIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "last_name",
      label: "Last Name *",
      placeholder: "Enter your last name",
      rules: { required: "Last Name is required" },
      icon: <PersonIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "email",
      label: "Email *",
      placeholder: "Enter your email",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^\S+@\S+$/i,
          message: "Enter a valid email address",
        },
      },
      icon: <EmailIcon />,
      sm: 6,
      xs: 12,
    },

    {
      name: "password",
      label: "Password *",
      placeholder: "Enter your password",
      icon: <Password />,
      type: "password",
      sm: 6,
      xs: 12,
    },
    {
      name: "country_code",
      options: countryForCode,
      label: "Code *",
      placeholder: "Select Country Code",
      rules: {
        required: "Code is Required",
      },
      sm: 2,
      xs: 4,
    },
    {
      name: "phone",
      label: "Phone *",
      placeholder: "Enter your phone number",
      type: "Number",
      rules: {
        required: "Phone number is required",
        pattern: {
          value: /^\d+$/,
          message: "Enter only numeric digits",
        },
      },
      icon: <PhoneIcon />,
      sm: 4,
      xs: 8,
    },

    {
      name: "address1",
      label: "Address 1 *",
      placeholder: "Enter your address",
      rules: { required: "Address is required" },
      icon: <LocationOnIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "address2",
      label: "Address 2",
      placeholder: "Enter your address",
      icon: <LocationOnIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "country",
      label: "Country *",
      placeholder: "Enter your country",
      rules: { required: "Country is required" },
      icon: <LocationOnIcon />,
      options: countryName,
      sm: 6,
      xs: 12,
    },
    {
      name: "state",
      label: "State *",
      placeholder: "Enter your state",
      rules: { required: "State is required" },
      icon: <LocationOnIcon />,
      options: stateName,
      sm: 6,
      xs: 12,
    },
    {
      name: "city",
      label: "City *",
      placeholder: "Enter your city",
      rules: { required: "City is required" },
      icon: <LocationOnIcon />,
      options: cityName,
      sm: 6,
      xs: 12,
    },

    {
      name: "pincode",
      label: "Pincode *",
      placeholder: "Enter your pincode",
      type: "Number",
      rules: {
        required: "Pincode is required",
        pattern: {
          value: /^[0-9]+$/,
          message: "Enter a valid numeric pincode",
        },
      },
      icon: <LocationOnIcon />,
      sm: 6,
      xs: 12,
    },

    {
      name: "iata_reg_no",
      label: "IATA Registration Number",
      placeholder: "Enter IATA Reg number",
      // rules: {
      //   required: "IATA Reg number is required",
      // },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "documents",
      label: "Upload Documents *",
      type: "file",
      placeholder: "Upload your documents",
      rules: {
        required: "Document upload is required",
        validate: {
          acceptedFormats: (files) => {
            if (!files || files.length === 0) return "Please upload a file";
            const allowedTypes = [
              "application/pdf",
              "application/msword",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ];
            return (
              allowedTypes.includes(files[0]?.type) ||
              "Only PDF, DOC, DOCX files are allowed"
            );
          },
        },
      },
      icon: <UploadFileIcon />,
      sm: 6,
      xs: 12,
      customRender: ({ name }) => (
        <Box
          display="flex"
          alignItems="center"
          width="100%"
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "10px",
            backgroundColor: "white",
          }}
        >
          <input
            type="file"
            onChange={handleFileUpload}
            accept=".pdf,.doc,.docx"
            style={{ display: "none" }}
            id="upload-documents"
          />
          <label htmlFor="upload-documents" style={{ flexGrow: 1 }}>
            <Button
              component="span"
              variant="outlined"
              startIcon={<UploadFileIcon />}
              sx={{
                textTransform: "none",
                width: "100%",
                justifyContent: "flex-start",
              }}
            >
              {selectedFileName ? selectedFileName : "Upload Documents *"}
            </Button>
          </label>
          {selectedFileName && (
            <IconButton
              size="small"
              onClick={() => {
                setValue(name, null);
                setSelectedFileName("");
              }}
              sx={{
                marginLeft: 1,
                backgroundColor: "rgba(0,0,0,0.1)",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.2)" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      ),
    },
  ];

  const indiaSpecificFields = [
    {
      name: "pan_number",
      label: "PAN Number",
      placeholder: "Enter PAN number",
      rules: {
        validate: {
          atLeastOneRequired: (value) => {
            const hasGstin = !!formValue.gstin_number;
            if (!value && !hasGstin) {
              return "Either PAN or GSTIN is required";
            }
            if (value) {
              // Only validate format if a value is entered
              const validFormat = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value);
              if (!validFormat) {
                return "Invalid PAN format (e.g., ABCDE1234F)";
              }
            }
            return true;
          },
        },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
    {
      name: "gstin_number",
      label: "GSTIN Number",
      placeholder: "Enter GSTIN number",
      rules: {
        validate: {
          atLeastOneRequired: (value) => {
            const hasPan = !!formValue.pan_number;
            if (!value && !hasPan) {
              return "Either PAN or GSTIN is required";
            }
            if (value) {
              // Only validate format if a value is entered
              const validFormat =
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
                  value
                );
              if (!validFormat) {
                return "Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)";
              }
            }
            return true;
          },
        },
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
  ];

  const companyRegField = [
    {
      name: "company_reg_number",
      label: "Company Registration Number *",
      placeholder: "Enter Company Reg number",
      rules: {
        required: "Company Reg number is required",
      },
      icon: <AccountBalanceIcon />,
      sm: 6,
      xs: 12,
    },
  ];
  function extractBase64(input) {
    let result = input?.split(/base64,/i)[1];

    if (result && result.includes("pngbase64")) {
      result = result?.split(/dataimage\/pngbase64/i)[1];
    }

    return result;
  }
  const navigate = useNavigate();
  const validateIndianFields = () => {
    if (countryId === 101) {
      // For India, check if at least one of PAN or GSTIN is provided
      if (!formValue.pan_number && !formValue.gstin_number) {
        setError("pan_number", {
          type: "manual",
          message: "Either PAN or GSTIN is required",
        });
        setError("gstin_number", {
          type: "manual",
          message: "Either PAN or GSTIN is required",
        });
        return false;
      }
    }
    return true;
  };
  const onSubmit = (data) => {
    if (!data?.documents) {
      toast.error("Document is Required", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }
    if (!validateIndianFields()) {
      return;
    }

    const payload = {
      ...data,
      user_type: "2",
      profile_url: "null",
      address1: data?.address1,
      address2: data?.address2,
      city: data.city?.value || data.city,
      state: data.state?.value || data.state,
      country: data.country?.value || data.country,
      country_code: data.country_code?.value || "",
      pan_number: data?.pan_number || "",
      gstin_number: data?.gstin_number || "",
      proof_image: extractBase64(data?.documents),
    };

    dispatch(addUserRequest(payload));
  };

  useEffect(() => {
    if (success) {
      localStorage.setItem("userEmail", watch("email"));
      toast.success("Registered successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetUserState());
          navigate(VERIFY_OTP);
        },
      });
    }

    if (error) {
      if (error.message === "Email must be unique") {
        setError("email", {
          type: "server",
          message: "Email must be unique",
        });
      }
      if (error.message === "Contact must be unique") {
        setError("phone", {
          type: "server",
          message: "Contact must be unique",
        });
      }
    }
  }, [success, error, navigate, dispatch, setError]);

  return (
    <>
      <TopBar unAuth={true} />
      <ToastContainer />
      <Box className="container">
        <Card sx={{ marginTop: "100px" }}>
          <CardContent className="card">
            <Typography variant="h5" className="form-heading">
              Vendor Registration
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                className="vendor-form-margin"
                container
                rowSpacing={4}
                columnSpacing={{ xs: 1, sm: 1, md: 1, lg: 3 }}
              >
                {vendorFields.map((field, index) => (
                  <Grid item xs={field.xs} sm={field.sm} key={index}>
                    {field.name === "password" ? (
                      <PasswordInput
                        name={field.name}
                        label={field.label}
                        placeholder={field.placeholder}
                        icon={field.icon}
                        control={control}
                      />
                    ) : field.customRender ? (
                      field.customRender({
                        name: field.name,
                        control: control,
                        label: field.label,
                        placeholder: field.placeholder,
                        startAdornment: field.icon,
                        rules: field.rules,
                        type: field.type,
                        options: field.options,
                        error: !!errors[field.name],
                        helperText: errors[field.name]?.message,
                      })
                    ) : (
                      <ControlledInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        type={field.type}
                        options={field.options}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    )}
                  </Grid>
                ))}
                {countryId === 101 &&
                  indiaSpecificFields.map((field, index) => (
                    <Grid item xs={field.xs} sm={field.sm} key={index}>
                      <ControlledInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    </Grid>
                  ))}

                {countryId !== 101 &&
                  companyRegField.map((field, index) => (
                    <Grid item xs={field.xs} sm={field.sm} key={index}>
                      <ControlledInputField
                        name={field.name}
                        control={control}
                        label={field.label}
                        placeholder={field.placeholder}
                        startAdornment={field.icon}
                        rules={field.rules}
                        error={!!errors[field.name]}
                        helperText={errors[field.name]?.message}
                      />
                    </Grid>
                  ))}

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        {...register("termsAccepted", {
                          required:
                            "You must accept the Terms and Privacy Policy to continue",
                        })}
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        I agree to the{" "}
                        <Link
                          href="https://atithiairportseva.com/terms-and-conditions/"
                          target="_blank"
                        >
                          Terms and Conditions
                        </Link>{" "}
                        and{" "}
                        <Link
                          href="https://atithiairportseva.com/privacy-policy/"
                          target="_blank"
                        >
                          Privacy Policy
                        </Link>
                      </Typography>
                    }
                  />
                  {errors.termsAccepted && (
                    <FormHelperText error>
                      {errors.termsAccepted.message}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Box className="button-container">
                    <CustomButton
                      variant="contained"
                      className="success-button"
                      type="submit"
                      loading={loading}
                      text={"submit"}
                    />
                  </Box>
                </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Box>
      <Footer />
    </>
  );
}
